import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import EventForm from '../../components/Events/EventForm';
import { getCurrentUser, getUserRole } from '../../services/supabase';

const PageContainer = styled.div`
  padding: 1rem;
  max-width: 800px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const PageTitle = styled.h2`
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 1.5rem;
`;

const NewEventPage = () => {
  const navigate = useNavigate();
  const [roleChecked, setRoleChecked] = useState(false);

  useEffect(() => {
    async function checkRole() {
      const { user } = await getCurrentUser();
      if (user) {
        const { role } = await getUserRole(user.id);
        if (role !== 'manager') {
          navigate('/dashboard', { replace: true });
        }
      } else {
        navigate('/dashboard', { replace: true });
      }
      setRoleChecked(true);
    }
    checkRole();
  }, [navigate]);

  const handleSuccess = (newEvent) => {
    navigate(`/events/${newEvent.id}`);
  };

  if (!roleChecked) return null; // or a spinner

  return (
    <PageContainer>
      <PageTitle>Create New Event</PageTitle>
      <EventForm onSuccess={handleSuccess} />
    </PageContainer>
  );
};

export default NewEventPage;